import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useFavouriteOrder'

import type { FavouriteOrderModel } from '@models/favouriteOrder'

interface FavouriteOrderListItemProps {
  favouriteOrder: FavouriteOrderModel,
}

const FavouriteOrderListItem = (props: FavouriteOrderListItemProps) => {
  const { favouriteOrder } = props

  const { id, title } = favouriteOrder

  const { agency } = useRelations(favouriteOrder)
  // @ts-expect-error TS2339
  const { title: agencyTitle } = agency

  return (
    <DashboardModuleListItem secondaryText={agencyTitle} title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default FavouriteOrderListItem
